import { useEffect, useState } from 'react'
import {
  legacyScheduleStateOffices,
  legacyScheduleStates,
  legacyScheduleStateSwatches,
  type LegacyScheduleState,
} from '../../mock/legacyScheduleState'
import './LegacyScheduleStateSetting.css'

function OfficeChosen({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  return <div className="legacy-g04-chosen" id="office_list_chosen">
    <span>{legacyScheduleStateOffices.find((office) => office.id === value)?.name}<i aria-hidden="true" /></span>
    <select id="office_list" aria-label="지점" value={value} onChange={(event) => onChange(event.target.value)}>{legacyScheduleStateOffices.map((office) => <option key={office.id} value={office.id}>{office.name}</option>)}</select>
  </div>
}

export function LegacyScheduleStateSetting() {
  const params = new URLSearchParams(window.location.search)
  const [office, setOffice] = useState(params.get('office') || '1')
  const [states, setStates] = useState<LegacyScheduleState[]>(legacyScheduleStates)
  const [picker, setPicker] = useState<{ id: string; left: number; top: number; value: string } | null>(null)
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [notice, setNotice] = useState<string | null>(null)

  useEffect(() => { document.title = '스케줄 상태 설정' }, [])
  const changeOffice = (value: string) => {
    setOffice(value)
    const next = new URLSearchParams(window.location.search)
    next.set('office', value)
    window.history.replaceState({}, '', `${window.location.pathname}?${next}`)
  }
  const updateColor = (id: string, color: string) => setStates((current) => current.map((state) => state.id === id ? { ...state, color } : state))
  const openPicker = (event: React.MouseEvent<HTMLButtonElement>, state: LegacyScheduleState) => {
    const rect = event.currentTarget.getBoundingClientRect()
    setPicker({ id: state.id, left: rect.right + .5, top: rect.bottom + 1.5, value: state.color || '#ff0000' })
  }
  const save = () => setConfirmOpen(true)
  const confirmSave = () => {
    setConfirmOpen(false)
    setNotice(`${states.length}개 스케줄 상태 색상을 Mock 저장했습니다. 실제 DB·API에는 전송하지 않았습니다.`)
  }

  return <div className="g_content_wrap legacy-g04">
    <div className="g_title">스케줄 상태 설정</div>
    <form id="sched_setting" onSubmit={(event) => event.preventDefault()}>
      <div className="g_row margin_bottom_10"><div className="g_input_wrap"><label className="g_label title" htmlFor="office_list">지점</label><OfficeChosen value={office} onChange={changeOffice} /></div></div>
      <div className="g_list_wrap g_scroll_bar"><table className="g_list"><colgroup><col style={{ width: 123.78125 }} /><col style={{ width: 155.875 }} /><col style={{ width: 123.78125 }} /><col style={{ width: 595.5625 }} /></colgroup><thead><tr><th>상태코드</th><th>색상</th><th>현재명칭</th><th>예시설명</th></tr></thead><tbody>{states.map((state) => <tr className="data_row" key={state.id}><td>{state.code}</td><td className="g_color_wrap"><button aria-label={`${state.name} 색상 선택`} className="g_color_btn" type="button" style={{ backgroundColor: state.color || 'transparent' }} onClick={(event) => openPicker(event, state)} /><button className="g_btn size_1 legacy-g04-transparent" type="button" onClick={() => updateColor(state.id, '')}>미지정</button></td><td>{state.name}</td><td className="left">{state.description}</td></tr>)}</tbody></table></div>
      <div className="g_btn_wrap center margin_top_10"><button type="button" id="submit_btn" className="g_btn save size_3" onClick={save}>저장</button></div>
    </form>
    {picker && <div id="clr-picker" className="legacy-g04-picker" style={{ left: picker.left, top: picker.top }}>
      <div className="clr-gradient" aria-hidden="true"><i /></div>
      <div className="clr-hue"><input aria-label="Hue slider" type="range" min="0" max="360" defaultValue="200" /></div>
      <div className="clr-preview" style={{ backgroundColor: picker.value }} />
      <input className="clr-color" aria-label="Color value field" value={picker.value} onChange={(event) => setPicker({ ...picker, value: event.target.value })} />
      <div className="clr-swatches">{legacyScheduleStateSwatches.map((color) => <button key={color} aria-label={color} type="button" style={{ backgroundColor: color }} onClick={() => setPicker({ ...picker, value: color })} />)}</div>
      <button className="clr-clear" type="button" aria-label="Clear the selected color" onClick={() => setPicker(null)}>취소</button>
      <button className="clr-close" type="button" aria-label="Close color picker" onClick={() => { updateColor(picker.id, picker.value); setPicker(null) }}>적용</button>
    </div>}
    {confirmOpen && <div className="legacy-g04-confirm-backdrop" role="presentation">
      <div className="legacy-g04-confirm" role="dialog" aria-modal="true" aria-labelledby="legacy-g04-confirm-title" onKeyDown={(event) => { if (event.key === 'Escape') setConfirmOpen(false) }}>
        <p id="legacy-g04-confirm-title">스케줄을 수정하시겠습니까?</p>
        <div><button type="button" autoFocus onClick={() => setConfirmOpen(false)}>취소</button><button type="button" className="primary" onClick={confirmSave}>확인</button></div>
      </div>
    </div>}
    {notice && <div className="legacy-g04-notice" role="status">{notice}<button type="button" aria-label="안내 닫기" onClick={() => setNotice(null)}>×</button></div>}
  </div>
}
